<template>
    <RewardLayout
        :headerText="headerText"
        :showSearch="true"
        :pageName="pageName"
        :modalController="modalController"
        :isAccountLoaded="isAccountLoaded"
        @clickBack="clickBack()">
        <template v-slot:content>
            <RewardCampaignList
                :category="selectedCategory"
                :modalController="modalController"
                :trackingService="trackingService"
                v-if="isLoaded" />
        </template>
    </RewardLayout>
</template>
<script>
// helper
import Util from '@/helper/Utility.js';
import Locale from '@/helper/locale/locale.js';
// mixin
import AccountMixin from '@/mixin/AccountMixin.js';
import ErrorApiMixin from '@/mixin/ErrorApiMixin.js';
import RewardMixin from '../mixin/RewardMixin';
// component
import RewardLayout from '../component/share/RewardLayout.vue';
import RewardCampaignList from '../component/Campaign/RewardCampaignList.vue';
export default {
    name: 'RewardCampaign',
    mixins: [AccountMixin, ErrorApiMixin, RewardMixin],
    components: {
        //layout
        RewardLayout,
        RewardCampaignList
    },
    data: function () {
        return {
            selectedCategory: null,
            headerText: '',
            localeCode: Locale.getLocaleCode(),
        }
    },
    created: function () {
        Util.scrollTop();
        this.errorHandler.setAlertModal(this.modalController.alertModal);
        this.errorHandler.setNoInternetModal(this.modalController.noInternetModal);
    },
    methods: {
        // mixin callback
        accountInitiated: function () {
            var cateId = this.$route.params.catId;
            var subCatId = this.$route.params.subCatId;
            if (cateId && subCatId) {
                this.initialMenuCategory(cateId, subCatId)
                    .then((res) => {
                        if (res) {
                            this.selectedCategory = res;
                            this.headerText = this.localeCode == 1033 ? res.name_en : res.name_th;

                            this.isLoaded = true;
                            this.hideLoading();
                        } else {
                            this.hideLoading();
                            this.$router.back();
                        }
                    }).catch((err) => {
                        this.hideLoading();
                        this.isLoaded = true;
                        this.isHaveItem = false;
                        this.errorApi(err, this.errorHandler);
                    });

            } else {
                this.isLoaded = true;
            }
        },
        //event
        clickBack: function () {
            this.$router.back();
        }
    }
}
</script>
